@let message = successMessageService.message();
@if (message) {
  <div class="toaster toaster-bottom toaster-center">
    <div class="alert alert-success px-4">
      {{ message | translate }}
    </div>
  </div>
}
